import BaseItem from "../BaseItem"
import {
  DATA_TYPE__JSON,
  FORM_ITEM__DEPARTMENT
} from "../types"

import Member from "./Member"

class Department extends Member {
  constructor() {
    super()
  }

  get title() {
    return this.fieldTitle || Department._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

Department._title = '部门选择'
Department.type = FORM_ITEM__DEPARTMENT
Department.use = true
Department.icon = 'iconfont icon-bumenguanli'

Department.prototype.type = Department.type
Department.prototype.dataType = DATA_TYPE__JSON

export default Department
